import React, { useRef } from 'react'
import { type UnstyledButtonProps, Text, UnstyledButton } from '@mantine/core'
import { LinkProps } from 'react-router-dom'

interface IRoundButton extends UnstyledButtonProps {
    label?: string
    onClick?: () => void
    component?:
        | 'button'
        | any
        | React.ForwardRefExoticComponent<
              LinkProps & React.RefAttributes<HTMLAnchorElement>
          >
    to?: string
    type?: 'button' | 'submit'
    variant?: 'filled' | 'default'
}

const RoundButton = ({
    onClick,
    label = 'Button',
    variant = 'filled',
    miw = 160,
    className,
    ...other
}: IRoundButton) => {
    const ref = useRef<HTMLButtonElement>(null)

    return (
        <UnstyledButton
            onClick={onClick}
            ref={ref}
            bg={variant === 'filled' ? 'blue.5' : 'gray.1'}
            className={
                variant === 'filled'
                    ? 'filled-hover-button'
                    : 'default-hover-button'
            }
            p='sm'
            px='xl'
            miw={miw}
            ta='center'
            styles={{
                root: {
                    borderRadius: '100px',
                },
            }}
            {...other}
        >
            <Text c={variant === 'filled' ? 'white' : 'text.2'} size='md'>
                {label}
            </Text>
        </UnstyledButton>
    )
}

export default RoundButton
